var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c("div", { staticClass: "child-view" }, [
    _c("h2", { staticClass: "heading-1 u-margin-top" }, [
      _vm._v(" " + _vm._s(_vm.$t("buyCredits.header")) + " ")
    ]),
    _vm.creditsDataStore
      ? _c(
          "div",
          { staticClass: "credits-slider-container" },
          [
            _c("CreditsSlider", {
              directives: [
                {
                  name: "show",
                  rawName: "v-show",
                  value: _vm.showSlider,
                  expression: "showSlider"
                }
              ],
              on: {
                showSlider: function($event) {
                  _vm.showSlider = $event
                },
                purchaseData: _vm.getPurchaseData
              }
            }),
            !_vm.showSlider
              ? _c("PaymentForm", {
                  attrs: { "purchase-data": _vm.purchaseData },
                  on: {
                    showSlider: function($event) {
                      _vm.showSlider = $event
                    },
                    makePurchase: _vm.purchaseCredits
                  }
                })
              : _vm._e()
          ],
          1
        )
      : _vm._e()
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }